import { Component, Input } from '@angular/core';
import { IDollarSummaryTotal, IHoursSummaryTotal, TotalOfTotals } from '../../time-sheets.type';

@Component({
	selector: 'app-hours-summary-totals',
	styleUrls: ['./totals.styles.scss'],
	templateUrl: './hours-summary-totals.component.html'
})
export class HoursSummaryTotalsComponent {
	@Input() title: string;
	@Input() firstColumnTitle: string;
	@Input() dollarTotals: IDollarSummaryTotal[];
	@Input() hoursTotals: IHoursSummaryTotal[];
	@Input() secondaryTotals: IHoursSummaryTotal[];
	@Input() secondaryTotalsHeader: string;
	@Input() totalOfHoursSummary: TotalOfTotals;
	@Input() isTotalDollars: boolean;
	displayedColumns: string[] = ['credit', 'hours', 'factor', 'adjustedHours'];
}
